var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sidebar-menu',{attrs:{"menu":_vm.menu,"collapsed":_vm.isSideBarExpanded},on:{"collapse":_vm.onCollapse,"item-click":_vm.onItemClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }